import React, { useState } from 'react'

/* ── Légende des couleurs du dashboard ────────────────────────────
   Affiché en bas de la sidebar. Aide à comprendre la signification
   de chaque couleur utilisée dans le tableau de bord.
   ─────────────────────────────────────────────────────────────── */

interface LegendEntry {
  color: string
  label: string
  description: string
}

const LEGEND_GROUPS: { title: string; items: LegendEntry[] }[] = [
  {
    title: 'État de santé',
    items: [
      { color: 'var(--health-good)',  label: 'OK',       description: 'Projet actif, aucune erreur' },
      { color: 'var(--health-warn)',  label: 'Alerte',   description: 'Avertissement ou en attente' },
      { color: 'var(--health-crit)', label: 'Critique',  description: 'Erreur bloquante' },
    ],
  },
  {
    title: 'Métriques',
    items: [
      { color: 'var(--chart-done)',    label: 'Terminé',  description: 'Tâches complétées' },
      { color: 'var(--chart-actions)', label: 'Actions',  description: 'Opérations Claude IA' },
      { color: 'var(--chart-git)',     label: 'Commits',  description: 'Commits git enregistrés' },
      { color: 'var(--chart-errors)',  label: 'Erreurs',  description: 'Erreurs & exceptions' },
      { color: 'var(--chart-warn)',    label: 'Bloqué',   description: 'Tâches bloquées / warnings' },
      { color: 'var(--chart-todo)',    label: 'À faire',  description: 'Tâches en attente' },
    ],
  },
]

export default function ColorLegend() {
  const [open, setOpen] = useState(false)

  return (
    <div className="color-legend">
      {/* Toggle */}
      <button
        onClick={() => setOpen(v => !v)}
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          width: '100%',
          background: 'transparent',
          border: 'none',
          cursor: 'pointer',
          padding: 0,
        }}
      >
        <span className="legend-title" style={{ margin: 0 }}>Légende couleurs</span>
        <span style={{
          fontSize: '9px',
          color: 'var(--text-dim)',
          fontFamily: 'var(--font-mono)',
          transition: 'transform 200ms',
          display: 'inline-block',
          transform: open ? 'rotate(180deg)' : 'rotate(0deg)',
        }}>▾</span>
      </button>

      {open && (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', marginTop: '6px' }}>
          {LEGEND_GROUPS.map(group => (
            <div key={group.title}>
              <div style={{
                fontSize: '9px',
                fontWeight: 700,
                letterSpacing: '0.08em',
                textTransform: 'uppercase',
                color: 'var(--text-dim)',
                marginBottom: '5px',
              }}>
                {group.title}
              </div>
              {group.items.map(item => (
                <div key={item.label} className="legend-item" title={item.description}>
                  <span
                    className="legend-swatch"
                    style={{ background: item.color }}
                  />
                  <span style={{ fontWeight: 600, color: 'var(--text-muted)', minWidth: 48 }}>
                    {item.label}
                  </span>
                  <span style={{ color: 'var(--text-dim)', fontSize: '10px' }}>
                    {item.description}
                  </span>
                </div>
              ))}
            </div>
          ))}
        </div>
      )}
    </div>
  )
}
